import { render, staticRenderFns } from "./Checkout.vue?vue&type=template&id=4e5e1d7a&scoped=true"
var script = {}
import style0 from "./Checkout.vue?vue&type=style&index=0&id=4e5e1d7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e5e1d7a",
  null
  
)

export default component.exports